define('plugin/client-login/model/ClientSignInModel',['require','lib/model/BaseModel','lib/validator/ValidatorEmail','lib/validator/ValidatorNotEmpty'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var ValidatorEmail = require('lib/validator/ValidatorEmail');
    var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');

    /**
     * Client sign in model
     *
     * @class ClientModel
     */
    return BaseModel.extend({

        url: '/ext/client/sign-in/',

        defaults: {
            is_logged_in: false,
            email: '',
            password: ''
        },

        initialize: function () {
            this.validators = {
                'email': [new ValidatorNotEmpty(), new ValidatorEmail()],
                'password': [new ValidatorNotEmpty()]
            };

            BaseModel.prototype.initialize.call(this);
        },

        signOut: function () {
            var url = this.baseUrl + '/ext/client/sign-out/';
            Backbone.ajax(url, {
                success: _.bind(function () {
                    this.trigger('sync');
                }, this)
            });
        }

    });

});
